<template>
  <div>
    <div class="content">
      <!--  头部  -->
      <div class="content_top" style="margin-top: 30px">
        <div class="header">
          <div>金米天成茶楼茶馆管理平台</div>
        </div>
        <div class="secondTittle">
          <div>《用户说》</div>
        </div>
      </div>
      <div class="secondTittle" style="text-align: left;padding: 10px">
        <!--        金杯银杯不如用户的口碑，2023新年伊始，金米天成热情又可爱的用户朋友发来使用体验和问候，我们对此心存感激，正是因为大家的参与和支持，让我们有勇气，在茶业数字化的道路上，坚定前行。-->
        <!--        在此依次展播，见证我们一起携手走过，未来我们将持续打磨产品，坚持用技术创新，为用户提供更高效和便捷的使用体验，不负信任。-->
        <div style="margin-top: 2px;text-indent: 2em;">
          金杯银杯不如用户的口碑，2023新年伊始，金米天成热情又可爱的用户朋友发来使用体验和问候。
        </div>
        <div style="margin-top: 2px;text-indent: 2em;">
          我们对此心存感激，有大家的参与和支持，让我们有勇气在茶业数字化的道路上，坚定前行。
        </div>
        <div style="margin-top: 2px;text-indent: 2em;">
          在此依次展播，见证我们一起携手走过，未来我们将持续打磨产品，坚持用技术创新，为用户提供更高效和便捷的使用体验，不负信任。
        </div>
        <!--        <div></div>-->
      </div>
      <div style="color: #a0a0a0;font-size: 12px;margin: 0 auto;text-align: left;padding: 15px">
        Tips: 陆续更新中，排名不分先后
      </div>
      <!--   内容区   -->
      <div>
        <!--    卡片    -->
        <div style="text-align: center;min-height: 150px;margin-top: 30px" v-for="(item,index) in videoList" :key="index">
          <!--  头部  -->
          <div class="content_top">
            <div class="secondTittle">
              <div>{{ item.title }}</div>
            </div>
            <div class="line"></div>
          </div>
          <div
              style="padding: 15px;text-align: left;margin: 0 auto;text-indent: 2em;font-size: 14px;color: #535353;line-height: 1.5em;">
            {{ item.secondTitle }}
          </div>
          <!--     视频播放     -->
          <div v-if="item.videoUrl !== ''" style="margin-bottom: 5px;margin-top: 5px">
            <!--      播放器区域      -->
            <div>
              <iframe style="width: 350px;height: 200px" :src="item.bilibili" scrolling="no"
                      border="0" frameborder="no" framespacing="0" allowfullscreen="true"></iframe>
            </div>
          </div>
          <div class="bottom_text text" :class="isShow ? 'text_isTrue' : ''" style="font-size: 12px">
            <div v-for="(txt,txtIndex) in item.textList" :key="txtIndex" @click="isShow = !isShow">
              {{ txt }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserSaid",
  created() {
  },
  data() {
    return {
      isShow: false,
      activeNames: ['1'],
      videoList: [
        {
          title: "春秋茶楼",
          videoUrl: "春秋茶楼魏鸿阳.mp4",
          bilibili: "//player.bilibili.com/player.html?bvid=BV1VA411o7Za&page=1",
          secondTitle: "春秋茶楼拥有五家直营店、三家加盟店包含多种计费模式、存取茶等相关业务",
          tips: "文字版",
          textList: [
            "大家好,我是春秋茶楼总经理魏鸿阳，春秋茶楼从2018年至今已经有五年了。",
            "这五年我们使用不下五个收银系统，之前的系统存在的问题非常多，总之会有短板，有的不可以房间计费，有的不可以进行总价计算，有的不可以进行总店统一化管理，",
            "但是在一次机缘巧合下，我们在北京的茶博会上遇到的耿总，也是遇到了金米天成，金米天成满足了我们现有的所有需求，在使用金米系统的这两年里，只要提出问题金米都会在短时间内进行解决，现在我们开到第五家分店了，使用金米天成系统真的帮助我们太多了，感谢金米天成团队。",
          ]
        },
        {
          title: "明德嘉业",
          bilibili: "//player.bilibili.com/player.html?bvid=BV1hP4y167zc&page=1",
          videoUrl: "明德嘉业创始人 李红兵.mp4",
          textList: [
            "大家好，我是明德嘉业茶书院，我们是2018年选用的金米系统，用了金米系统以后，进销存，这个体系上是非常清晰的，进销存从纵向到横向拓宽了很多业务，业务越来越清晰，金米系统对于复杂的业务都解决的相当好，用起来非常的方便，金米系统给我们明德嘉业带来很大的帮助，我们明德嘉业的核心就是金米的管理系统，现在也离不开金米系统了。大家好，我是明德嘉业茶书院，我们是2018年选用的金米系统，用了金米系统以后，进销存，这个体系上是非常清晰的，进销存从纵向到横向拓宽了很多业务，业务越来越清晰，金米系统对于复杂的业务都解决的相当好，用起来非常的方便，金米系统给我们明德嘉业带来很大的帮助，我们明德嘉业的核心就是金米的管理系统，现在也离不开金米系统了。"
          ]
        },
        {
          title: "峟茶齐迹",
          bilibili: "//player.bilibili.com/player.html?bvid=BV1vG4y1C7wT&page=1",
          videoUrl: "峟茶齐迹.mp4",
          text: "",
          textList: [
            "大家好,我是峟茶茶空间主理人齐迹，使用金米天成管理系统当中财务管理给我们提供了很大的帮助，使用系统之前用手工记账，整理起来费时费力，管理者决策缺乏依据。",
            "用了金米天成系统之后，通过不同的维度统计门店的经营状况，同时提供了可视化图表，例如营收分析、商品销售分析、员工业绩分析、利润分析等数据清晰明了，而且我们反馈的问题金米天成客服都能及时解决，还有定期的线上培训，帮助我们员工快速上手。金米天成系统值得拥有，选茶行业管理系统就用金米天成。",
          ]
        },
        {
          title: "三味茶屋",
          bilibili: "//player.bilibili.com/player.html?bvid=BV1B84y1b7bL&page=1",
          videoUrl: "三味茶屋刘公子.mp4",
          textList: [
            "大家好,我是三亚三味茶屋的主理人刘公子，非常感谢金米天成提供的比较好的操作系统，无论是前期的培训讲解还是后期的问题对接，让我们感受到了金米天成的专业度和温度，同时解决问题的时效性，希望金米天成系统越做越好。"
          ]
        },
        {
          title: "溢茗坊",
          bilibili: "//player.bilibili.com/player.html?bvid=BV1a84y1b7gT&page=1",
          videoUrl: "溢茗坊李诗航竖版.mp4",
          textList: [
            "大家好，我是北京市朝阳区溢茗坊的雨林古树茶的店名负责人我是李诗航，加入金米天成系统是在21年的4月份，它是我从事茶行业这么久以来，用过了无数茶楼系统里，唯一一个可以让我感到惊喜的一个茶楼系统，它是从我们的电脑端到手机端，它的初始化操作就带给我了足够大的惊喜，可以说是从客人的茶室预定再到消费、消费转台、消费计时，这一系列的最强操作性都可以在电脑端或是手机端实现，让客人的账目一目了然，还有就是我们店面员工的收入提成都是笔笔清晰，它可以实现同一笔订单多个人员销售的销售统计。库存管理这方便呢，给予我们提供了很大的帮助，满足我们随时随地的查看店面的实时库存，解决了我们对进销存这一系列问题，对于库存转换呢，我们一定要点个赞，它的库存转换可以满足我们对于散茶的管理。例如说将饼茶撬开为散茶之后在转换入库，这样就可以实现我们的店面迎接用茶、我们的员工练习茶还有我们的房间使用泡茶，在使用后可以精准的自动减消库存。在没有使用金米天成系统之前，库存盘点对于我来说是一个很头疼的问题，每一次盘点都要耗上3-4天这样的时间，耗时耗力不说还不一定够精准，自从使用了金米天成系统之后，它更是让我见识到了它的简单高效，它可以按照类别、按动态、按全盘等多种方式进行盘点，降本增效。同时我们反馈给金米天成客服的问题，都能在第一时间得到解决，还会有定期的线上培训，可以帮助我们的员工快速上手，选择茶行业管理系统，一定要选金米天成。就让这智慧的羽翼祝您事业腾飞。大家好，我是北京市朝阳区溢茗坊的雨林古树茶的店名负责人我是李诗航，加入金米天成系统是在21年的4月份，它是我从事茶行业这么久以来，用过了无数茶楼系统里，唯一一个可以让我感到惊喜的一个茶楼系统，它是从我们的电脑端到手机端，它的初始化操作就带给我了足够大的惊喜，可以说是从客人的茶室预定再到消费、消费转台、消费计时，这一系列的最强操作性都可以在电脑端或是手机端实现，让客人的账目一目了然，还有就是我们店面员工的收入提成都是笔笔清晰，它可以实现同一笔订单多个人员销售的销售统计。库存管理这方便呢，给予我们提供了很大的帮助，满足我们随时随地的查看店面的实时库存，解决了我们对进销存这一系列问题，对于库存转换呢，我们一定要点个赞，它的库存转换可以满足我们对于散茶的管理。例如说将饼茶撬开为散茶之后在转换入库，这样就可以实现我们的店面迎接用茶、我们的员工练习茶还有我们的房间使用泡茶，在使用后可以精准的自动减消库存。在没有使用金米天成系统之前，库存盘点对于我来说是一个很头疼的问题，每一次盘点都要耗上3-4天这样的时间，耗时耗力不说还不一定够精准，自从使用了金米天成系统之后，它更是让我见识到了它的简单高效，它可以按照类别、按动态、按全盘等多种方式进行盘点，降本增效。同时我们反馈给金米天成客服的问题，都能在第一时间得到解决，还会有定期的线上培训，可以帮助我们的员工快速上手，选择茶行业管理系统，一定要选金米天成。就让这智慧的羽翼祝您事业腾飞。"
          ]
        },
        {
          title: "观味茶香",
          bilibili: "//player.bilibili.com/player.html?bvid=BV1bv4y1179J&page=1",
          videoUrl: "观味茶香 刘卓.mp4",
          textList: [
            "大家好，我是观味茶香品牌主理人刘卓，我们从2018年开始使用金米天成系统，对我的感受就是方便、快捷、好操作，它可以做到茶馆的多种收费方式同时存在，例如：像包间按小时计费、套餐不计时和商品不同折扣可以同时存在，这样对于我们收银结账来说就非常的方便，还有就是它的库存管理，我们可以有效的知道商品缺货情况，提醒我们去及时的补库存。还有员工的业绩统计，包括 营业报表的查询都是非常的方便，这样对于我们月底做账来说就会很方便，可以形成图文的表格。会员情况会做的非常的详细，我们可以清晰的知道客户的存茶取茶情况、充值情况还有他的消费情况，可以针对不同的客户单独送代金券或者是其他都是可以的。这样它可以更有效的去帮助我们提高营业额，我们反馈的问题金米天成客服都能及时的解决，还有定期的线上培训，帮助我们的员工快速上手。金米天成系统值得拥有，选茶行业管理系统，就用金米天成。"
          ]
        },
        {
          title: "雨林华贸",
          bilibili: "//player.bilibili.com/player.html?bvid=BV1Vx4y1u73T&page=1",
          videoUrl: "雨林华贸店樊非凡.mp4",
          textList: [
            "大家好，我是雨林古树茶北京华贸店的经营者。我叫繁非凡，我是从前年开业一直使用的金米系统，金米系统帮助我的几点：第一点，方便我们的员工操作，它可以根据自己的需求、根据对客户的分析，可以赠送代金券赠送积分、金额。第二点，我们针对不同的会员有不同等级、不同的折扣，也可以根据产品进行不同的折扣都可以实现，对于店长或是管理者来说，金米系统有个非常好的优点，可以很精准很简洁的统计一些数据，包括会员，多久没来，余额还有多少，帮助我们进行客户的分析，员工的业绩也是很方便查询的。最后一点也是非常重要的一点，我们的客人可以从手机上关注我们的公众号，可以查询顾客自己的消费情况，上次消费情况、余额剩余情况、积分、存取茶等相关的明细都能体现出来，还有一个很重要的点是金米系统的服务人员，他们客服可以说是随叫随到，对我们的帮助也很大，也会经常进行线上的培训，这样能更有效的帮助我们快速上手，所以大家选择金米系统就对了。"
          ]
        },
        {
          title: "香格里茶楼",
          bilibili: "//player.bilibili.com/player.html?bvid=BV12x4y1u7TK&page=1",
          videoUrl: "香格里茶楼.mp4",
          textList: [
            "大家好，我是香格里茶楼，我们茶楼是在成都龙泉，茶楼的面积有1000多平，我们主营茶、甜品、咖啡还有一些简餐、主餐。我们是2017年8月23日正式使用金米系统，在我们开茶楼之前，我们也有其他店使用的其他系统，用其他系统使用的过程中都会出现一些问题，自从跟金米合作以后，我觉得服务各方面是做的非常的好，包括包间收费，我们白天和夜间的收费是不同的，白天的话是计时费和包间费，夜间以后就是计时费、包间费还有叠加的计时和服务费，所以其他系统都实现不了，自从用了金米系统以后，这个细节做的非常的好，包括一些项目类别、库存等等做的都非常的到位。比如说很小的一件事情，桌台我们不会设置，当我们跟工作人员联系的时候，他们会第一时间为我们解决问题，这个点赞。我们之前也开过其他的店，其他店的系统都不是特别的满意，以后再开分店的话，第一肯定跟北京金米合作，因为特别要感谢耿先生，虽然我们认识的时间不长，但是他的工作效率和服务都非常的好，包括一些很小的问题我们解决不了，他都会跟我们视频、远程把事情解决好，所以说在这里特别的感谢金米的负责人、工作人员还有就是耿先生，不管再晚打电话或是微信，他都是给我们解决问题，所以说这个系统使用起来真的是细节上真的完美，没有漏洞、员工操作起来也没有问题，就是做的非常的好，谢谢。"
          ]
        }, {
          title: "澜沧古茶北京通州旗舰店",
          bilibili: "//player.bilibili.com/player.html?bvid=BV1bx4y1u7vc&page=1",
          videoUrl: "茶馆办李守望主任介绍 茶馆办.mp4",
          textList: [
              "大家好，我是澜沧古茶北京通州旗舰店店长郭小梅，对于金米系统的升级真的非常感谢，用一句话说千恩万谢，因为帮助我们省了太大的劳动力和脑力了，对于相关的数据会自动保存，查询数据，只要输入相关内容，系统就会智能快速的搜索出来了，发自内心的感谢金米，金米系统这些年给我带来太多的方便了，千恩万谢，都是发自内心的肺腑之言。"
          ]
        }
      ],
      old_id: "",
    }
  },
  methods: {
    handleChange(val) {
      console.log(val);
    },
    zhanKai(v) {
      this.isShow = !this.isShow;
    }
  }
}
</script>

<style>
body {
  overflow-x: unset;
}

.content {
  color: black;
  /*background: url('@/assets/video/茶背景图2.jpg') no-repeat;*/
  margin: 0 auto 100px;
}

.card_title div:first-child {
  width: 100%;
  margin: 0 auto;
}

.content_top {
  margin-top: 10px;
  /*margin-bottom: 30px;*/
}

.header div:first-child {
  width: 300px;
  margin: 0 auto;
  text-align: center;
  height: 40px;
  font-size: 25px
}

.secondTittle {
  width: auto;
  margin: 0 auto;
  text-align: center;
  font-weight: normal;
  font-size: 16px;
  color: #535353;
}

.line {
  width: 300px;
  margin: 10px auto;
  border-bottom: 5px solid #57b05b
}

.bottom_text {
  padding-left: 10px;
  padding-right: 10px;
  margin: 0 auto;
  text-align: left;
  text-indent: 2em;
  font-size: 18px;
  color: #535353;
  line-height: 1.5em
}


.text {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  overflow: hidden;
  -webkit-box-orient: vertical;
}

.text_isTrue {
  display: block !important;
}

.text::before {
  content: '';
  float: right;
  width: 0; /*设置为0，或者不设置宽度*/
  height: 50px; /*先随便设置一个高度*/
}

.btn {
  float: right;
  /*其他装饰样式*/
  width: 15px;
  margin-top: 50px;
}
</style>